import { nanoid } from "nanoid";

import Start from "./components/Start";
import { Quiz } from "./components/Quiz";
import { Footer } from './components/Footer';

import { useEffect, useState } from "react";
import React from "react";

function App() {
  const [quizStarted, setQuizStarted] = useState(false);
  const [hasCheckedAnswers, setHasCheckedAnswers] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [rightAnswerCount, setRightAnswerCount] = useState(0);

  useEffect(() => {
    async function fetchData() {
      try {
        if (quizStarted) {
          const response = await fetch(
            "https://opentdb.com/api.php?amount=5&category=17&difficulty=hard&type=multiple"
          );
          const quiz = await response.json();
          setQuestionData(quiz.results);
        }
      } catch (error) {
        console.log(error);
      }
    }
    void fetchData();
  }, [quizStarted]);

  useEffect(() => {
    function generateAnswers(dataItem) {
      const answersArray = dataItem.incorrect_answers;

      const randomIndex = Math.floor(Math.random() * 3);
      answersArray.splice(randomIndex, 0, dataItem.correct_answer);

      return answersArray.map((answer) => ({
        id: nanoid(),
        text: answer,
        isSelected: false,
      }));
    }
    if (questionData && questionData.length > 0) {
      setQuestions(
        questionData.map((item) => ({
          id: nanoid(),
          question: item.question,
          correctAnswer: item.correct_answer,
          answers: generateAnswers(item),
        }))
      );
    }
  }, [questionData]);

  function selectAnswer(questionId, answerId) {
    setQuestions((oldQuestions) =>
      oldQuestions.map((question) =>
        question.id !== questionId
          ? question
          : {
              ...question,
              answers: question.answers.map((answer) =>
                answer.id !== answerId
                  ? { ...answer, isSelected: false }
                  : { ...answer, isSelected: true }
              ),
            }
      )
    );
  }

  function checkAnswers() {
    let correctAnswerCount = 0;
    questions.forEach((question) => {
      const selectedAnswer = question.answers.find(
        (answer) => answer.isSelected
      );
      if (selectedAnswer) {
        if (selectedAnswer.text === question.correctAnswer) {
          correctAnswerCount++;
        }
      }
    });
    setRightAnswerCount(correctAnswerCount);
    setHasCheckedAnswers(true);
  }

  function playAgain() {
    setRightAnswerCount(0);
    setHasCheckedAnswers(false);
    setQuizStarted(false);
  }

  function startQuiz() {
    setQuizStarted(true);
  }

  return (
    <div className="App">
      {!quizStarted ? (
        <Start startQuiz={startQuiz} />
      ) : (
        <div>
          <div className="questions">
            {questions.map((item, index) => (
              <React.Fragment key={item.id}>
                <Quiz
                  quiz={item}
                  hasCheckedAnswers={hasCheckedAnswers}
                  selectAnswer={(selectedId) =>
                    selectAnswer(item.id, selectedId)
                  }
                />
                {questions.length - 1 !== index && <hr />}
              </React.Fragment>
            ))}
            <div iv className="checkQuestions--lbl">
              {hasCheckedAnswers ? (
                <div>
                  <p>
                    You scored {rightAnswerCount + "/" + questions.length}{" "}
                    correct answers
                  </p>
                  <button className="btn check--btn" onClick={playAgain}>
                    Play again
                  </button>
                </div>
              ) : (
                <button className="btn check--btn" onClick={checkAnswers}>
                  Check answers
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    <Footer />
    </div>
  );
}

export default App;
